import { Crown, Star, Zap, User, ShieldCheck } from 'lucide-react';
import { TIER_LABEL } from '@/components/dashboard/access';

// Nivel real del usuario en la cabecera (Free / Access / PRO / Premium · Broker / Admin)
const TIER_STYLES = {
  free: { icon: User, className: 'bg-white/[0.04] text-gray-300 border-white/15' },
  access: { icon: Zap, className: 'bg-[#8b5cf6]/[0.08] text-[#a78bfa] border-[#8b5cf6]/30' },
  pro: { icon: Star, className: 'bg-[#c9a84c]/[0.08] text-[#c9a84c] border-[#c9a84c]/30' },
  premium: { icon: Crown, className: 'bg-gradient-to-r from-[#c9a84c] to-[#d4b357] text-[#0a1628] border-[#c9a84c]' },
  admin: { icon: ShieldCheck, className: 'bg-[#c9a84c]/[0.06] text-[#c9a84c] border-[#c9a84c]/20' },
};

export function TierBadge({ tier = 'free', label }) {
  const style = TIER_STYLES[tier] || TIER_STYLES.free;
  const Icon = style.icon;
  const text = label || TIER_LABEL[tier] || TIER_LABEL.free;
  return (
    <span
      className={`inline-flex items-center gap-1 text-[11px] border rounded-full px-2.5 py-1 uppercase tracking-wider font-semibold whitespace-nowrap ${style.className}`}
      data-testid="tier-badge"
      title={`Tu nivel: ${text}`}
    >
      <Icon size={10} strokeWidth={2.5} aria-hidden="true" />
      {text}
    </span>
  );
}

const STYLES = {
  premium: {
    label: 'Premium',
    shortLabel: 'Premium',
    icon: Crown,
    className: 'bg-gradient-to-r from-[#c9a84c] to-[#d4b357] text-[#0a1628] border-[#c9a84c]',
  },
  basica: {
    label: 'PRO',
    shortLabel: 'PRO',
    icon: Star,
    className: 'bg-[#c9a84c]/[0.08] text-[#c9a84c] border-[#c9a84c]/30',
  },
  starter: {
    label: 'Access',
    shortLabel: 'Access',
    icon: Zap,
    className: 'bg-[#8b5cf6]/[0.08] text-[#a78bfa] border-[#8b5cf6]/30',
  },
};

/**
 * Badge visual del plan activo.
 * Variants:
 *   "pill"    — pastilla compacta con icono + texto (default, para header)
 *   "inline"  — mini icono sin texto (para junto a nombre en sidebar)
 *   "compact" — icono + texto pequeño sin fondo (para listas)
 */
export function MembershipBadge({ membership, variant = 'pill' }) {
  if (!membership) return null;
  const style = STYLES[membership];
  if (!style) return null;

  const Icon = style.icon;

  if (variant === 'inline') {
    return (
      <span
        className={`inline-flex items-center justify-center w-4 h-4 rounded-full ${style.className} shrink-0`}
        title={style.label}
      >
        <Icon size={10} strokeWidth={2.5} />
      </span>
    );
  }

  if (variant === 'compact') {
    const compactColor = membership === 'starter' ? 'text-[#a78bfa]' : 'text-[#c9a84c]';
    return (
      <span className={`inline-flex items-center gap-1 text-[11px] uppercase tracking-wider font-semibold ${compactColor}`}>
        <Icon size={10} />
        {style.shortLabel}
      </span>
    );
  }

  // pill (default) — usa shortLabel para no romper layouts apretados
  return (
    <span
      className={`inline-flex items-center gap-1 text-[11px] border rounded-full px-2.5 py-0.5 uppercase tracking-wider font-semibold ${style.className}`}
    >
      <Icon size={10} strokeWidth={2.5} />
      {style.shortLabel}
    </span>
  );
}
